import Vue from 'vue'
import VueRouter from 'vue-router'

import Dashboard from './pages/dashboard/DashboardPage'
import Initial from './pages/dashboard/Initial'
import Profile from './pages/profile/Profile'
import User from './pages/user/User'
import DataCollection from './pages/data-collection/DataCollection'
import Checking from './pages/checking/Checking'
import AdminBreak from './pages/break/AdminBreak'
import UploadStatus from './pages/upload/UploadStatus'
import InventoryTable from './pages/InventoryTable/InventoryTable'
import CollectedItems from './pages/CollectedItems/CollectedItems'
import Devices from './pages/Devices/Devices'

import Login from './components/layout/Login.vue'
import Admin from './components/layout/Admin.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Initial,
        name: "Initial",
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5] }
    },
    {
        path: '/login',
        component: Login,
        name: "Login",
        meta: { layout: Login, guestOnly: true }
    },
    {
        path: '/profile',
        component: Profile,
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5]}
    },
		{
        path: '/dashboard',
        component: Dashboard,
        name: "Dashboard",
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5] }
    },
		{
        path: '/users',
        component: User,
        meta: { layout: Admin, authOnly: true ,roles:[1,2] }
    },
		{
        path: '/data-collection',
        component: DataCollection,
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5] }
    },
		{
        path: '/checking',
        component: Checking,
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5] }
    },
		{
        path: '/break',
        component: AdminBreak,
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5] }
    },
		{
        path: '/upload_status',
        component: UploadStatus,
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5] }
    },
		{
        path: '/inventory-table',
        component: InventoryTable,
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5] }
    },
		{
        path: '/collected-items',
        component: CollectedItems,
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5] }
    },
		{
        path: '/devices',
        component: Devices,
        meta: { layout: Admin, authOnly: true ,roles:[1,2,3,4,5] }
    }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
function isLoggedIn() {
	console.log(localStorage.getItem("auth"));
  return localStorage.getItem("auth");
}
router.beforeEach((to, from, next) => {
	////console.log(root.data.user);
	if(to.path.substring(0,4) == '/api'){
		to.path = to.path.substring(4);
	}
	/*
	if(document.getElementById('modal')){
		Vue.$vm2.close('vue-modal-2');
		//console.log('ok');
	}
	else{
		//console.log('nincs modal');
	}
	*/
	/*
	var user = JSON.parse(localStorage.getItem('user'));
  //EZT A SZART ESSZEL MERT VEGTEKLEN CIKLUS LESZ HA NINCS BENNE A ROLE
	if(to.meta.roles != undefined && user != null){
		if(!to.meta.roles.includes(user.role_id)){
			next({
        path: "/dashboard",
        query: { redirect: to.fullPath }
      });
			//console.log('nem');
		}else{
			//console.log('igen');
		}
	} */
	
  if (to.matched.some(record => record.meta.authOnly)) {
		
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guestOnly)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (isLoggedIn()) {
			
      next({
        path: "/dashboard",
        query: { redirect: to.fullPath }
      });
    } else {
			console.log('redirected to lolgin');
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
